import { render, staticRenderFns } from "./ModuleSelector.vue?vue&type=template&id=454f14b6"
import script from "./ModuleSelector.vue?vue&type=script&lang=js"
export * from "./ModuleSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/minhochoi/projects/MAPPING/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('454f14b6')) {
      api.createRecord('454f14b6', component.options)
    } else {
      api.reload('454f14b6', component.options)
    }
    module.hot.accept("./ModuleSelector.vue?vue&type=template&id=454f14b6", function () {
      api.rerender('454f14b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ModuleSelector.vue"
export default component.exports